module.exports = __webpack_public_path__ + "img/IMG_20191125_200046.057abc36.jpg";